module.exports = __webpack_public_path__ + "assets/img/down.17d0b444.png";